import { createFetchAction, createPromiseAction } from '../../utils';

export const devicesLicenseAction = {
  ...createFetchAction('devices-license'),
};

export const fetchDevicesLicenseAction = createPromiseAction(
  'device-license/FETCH_DEVICES_LICENSE'
);
